import { connect } from 'react-redux'
import actions from 'actions/dashboardTemplates'
import Component from 'components/DashboardTemplates/Select/Filter'

export default connect(null, { getChartMetricTypes: actions.getChartMetricTypes })(Component)
